import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { AirportFeeSummaryComponent } from '../airport-fee-summary/airport-fee-summary.component';
import { QuickNavComponent } from '../../shared/quick-nav/quick-nav.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { AirportService } from '../airport.service';
import { AddBusinessDialogComponent } from '../add-business-dialog/add-business-dialog.component';
import { EditNavaidComponent } from '../edit-navaid/edit-navaid.component';
import { EditCommunicationComponent } from '../edit-communication/edit-communication.component';
import { Source } from '../../shared/models/source.model';
import { QuickNavToc } from '../../shared/models/quick-nav-toc.model';
import { EditOperationsComponent } from '../edit-operations/edit-operations.component';
var AirportIslandDetailComponent = /** @class */ (function () {
    function AirportIslandDetailComponent(_businessManagerService, _toggleService, _matDialog, _router, _airportService, _snackBar) {
        this._businessManagerService = _businessManagerService;
        this._toggleService = _toggleService;
        this._matDialog = _matDialog;
        this._router = _router;
        this._airportService = _airportService;
        this._snackBar = _snackBar;
        this.toc = new QuickNavToc('airport-quicknav', [{
                label: 'Overview',
                fragment: 'overview',
                visible: true
            }, {
                label: 'FBOs',
                fragment: 'fbos',
                visible: true
            }, {
                label: 'Food/Lodging/Activities',
                fragment: 'local',
                visible: true
            }, {
                label: 'Flying Clubs',
                fragment: 'flyingclubs',
                visible: true
            },
            {
                label: 'Runways',
                fragment: 'runways',
                visible: true
            }, {
                label: 'Procedures',
                fragment: 'procedures',
                visible: true
            }, {
                label: 'Operations',
                fragment: 'operations',
                visible: true
            }, {
                label: 'Comms',
                fragment: 'comms',
                visible: true
            }, {
                label: 'Weather',
                fragment: 'wx',
                visible: true
            }]);
        this.isFlightDeckAdmin = false;
        this.editModeSet = false;
        this.isAirportManager = false;
        this.isSubscribedToIslandGuide = false;
        this.isCaribbeanOrBahamasIsland = false;
    }
    Object.defineProperty(AirportIslandDetailComponent.prototype, "businessesWithFees", {
        /**
         * Returns a subset of the list of businesses at this airport that either (1) have overview fees reported, or (2)
         * provide fuel. This is used for displaying the fee summary section, which is meant to list all FBOs which may
         * have fees. In the case where fees are not reported, a placeholder message is shown saying the location has not
         * disclosed fees.
         */
        get: function () {
            return this.airport.businesses.filter(function (b) { return AirportService.shouldShowFees(b); });
        },
        enumerable: true,
        configurable: true
    });
    AirportIslandDetailComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e;
            var _this = this;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.userManagesAirport(this.airport.airportId)];
                    case 1:
                        _a.isAirportManager = _f.sent();
                        _b = this;
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 2:
                        _b.isFlightDeckAdmin = _f.sent();
                        _c = this;
                        _d = this.getIslandGuideSubscriptionState;
                        return [4 /*yield*/, this._businessManagerService.isSubscribedToCaribbeanGuide()];
                    case 3:
                        _e = [_f.sent()];
                        return [4 /*yield*/, this._businessManagerService.isSubscribedToBahamasGuide()];
                    case 4:
                        _c.isSubscribedToIslandGuide = _d.apply(this, _e.concat([_f.sent()]));
                        this.isCaribbeanOrBahamasIsland = this.airport.sourceId === Source.CaribbeanGuide || this.airport.sourceId === Source.BahamasGuide;
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        this.oldAirport = this.airport;
                        return [2 /*return*/];
                }
            });
        });
    };
    /* async ngDoCheck() {
       /
        * This hack is to handle routes coming from the autocomplete search.
        * Without it, an airport manager would look like they could manage airports they don't have permission to manage.
        * The API prevents any actual changes regardless of what the interface shows without this hack.
        /
      if (this.airport && this.oldAirport && this.airport.airportId !== this.oldAirport.airportId) {
        this.oldAirport = this.airport;
        this.isAirportManager = await this._businessManagerService.userManagesAirport(this.airport.airportId);
        if (!this.isAirportManager) {
          this._toggleService.setState(false);
        }
      }
    } */
    AirportIslandDetailComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(AirportIslandDetailComponent.prototype, "sortedFBOs", {
        get: function () {
            if (!this.isFlightDeckAdmin) {
                return this.airport.businesses
                    .filter(function (b) { return b.isFbo; })
                    .filter(function (fbo) { return !fbo.hideBusiness; })
                    .filter(function (fbo) { return !fbo.notApproved; })
                    .sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
            }
            return this.airport.businesses
                .filter(function (b) { return b.isFbo; })
                .sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    AirportIslandDetailComponent.prototype.onReloadAirport = function (reload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AirportIslandDetailComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AirportIslandDetailComponent.prototype.openAddDialog = function (facilityType) {
        var _this = this;
        var dialogRef = this._matDialog.open(AddBusinessDialogComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                airport: this.airport,
                facilityType: facilityType
            }
        });
        dialogRef.afterClosed().subscribe(function (closeDialog) {
            if (closeDialog.cancelButtonClicked) {
                return;
            }
            if (closeDialog.success) {
                var type = void 0;
                if (facilityType === 'FLYING CLUB') {
                    type = 'flyingclub';
                }
                else if (facilityType === 'BUSINESS') {
                    type = 'business';
                }
                _this.reloadAirport(_this.airport.identifier);
                _this._router.navigateByUrl("/" + type + "/" + closeDialog.payload);
            }
        });
    };
    AirportIslandDetailComponent.prototype.openAddNavaidDialog = function () {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        var dialogRef = this._matDialog.open(EditNavaidComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                airportId: this.airport.airportId,
                isNew: true,
                navaid: null
            }
        });
        dialogRef.afterClosed().subscribe(function (closeDialog) {
            if (!closeDialog) {
                return;
            } // required to handle backdrop click.
            if (closeDialog.cancelBtnClicked) {
                return;
            }
            if (closeDialog.success) {
                _this.reloadAirport(_this.airport.identifier);
                _this._snackBar.open('Navaid', 'Added', {
                    duration: 2000
                });
            }
            else {
                if (closeDialog.error != null) {
                    ERROR_MSG = closeDialog.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    AirportIslandDetailComponent.prototype.openAddCommsDialog = function () {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        var dialogRef = this._matDialog.open(EditCommunicationComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                airportId: this.airport.airportId,
                isNew: true,
                comm: null
            }
        });
        dialogRef.afterClosed().subscribe(function (closeDialog) {
            if (!closeDialog) {
                return;
            } // required to handle backdrop click.
            if (closeDialog.cancelBtnClicked) {
                return;
            }
            if (closeDialog.success) {
                _this.reloadAirport(_this.airport.identifier);
                _this._snackBar.open('Communication', 'Added', {
                    duration: 2000
                });
            }
            else {
                if (closeDialog.error != null) {
                    ERROR_MSG = closeDialog.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    AirportIslandDetailComponent.prototype.openEditOperationsDialog = function (airport) {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        var dialogRef = this._matDialog.open(EditOperationsComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                airport: this.airport
            }
        });
        dialogRef.afterClosed().subscribe(function (closeDialog) {
            if (!closeDialog) {
                return;
            } // required to handle backdrop click.
            if (closeDialog.cancelBtnClicked) {
                return;
            }
            if (closeDialog.success) {
                _this.reloadAirport(_this.airport.identifier);
                _this._snackBar.open('Operations', 'Updated', {
                    duration: 2000
                });
            }
            else {
                if (closeDialog.error != null) {
                    ERROR_MSG = closeDialog.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    AirportIslandDetailComponent.prototype.getIslandGuideSubscriptionState = function (hasCaribbeanAccess, hasBahamasAccess) {
        if ((this.airport.sourceId === Source.CaribbeanGuide && hasCaribbeanAccess) ||
            (this.airport.sourceId === Source.BahamasGuide && hasBahamasAccess)
            || this.isAirportManager) {
            return true;
        }
        else {
            return false;
        }
    };
    return AirportIslandDetailComponent;
}());
export { AirportIslandDetailComponent };
